module.exports = __webpack_public_path__ + "img/33.6.CODm.0d008c18.png";